<template>
  <div class="px-6 py-3 border-b" style="background: var(--background-secondary); border-color: var(--border-light);">
    <Breadcrumb :model="items" class="breadcrumb-custom">
      <template #item="{ item }">
        <span
          :class="[
            'breadcrumb-item',
            item.command ? 'cursor-pointer hover:text-blue-600' : 'text-gray-500'
          ]"
          @click="item.command"
        >
          {{ item.label }}
        </span>
      </template>
    </Breadcrumb>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Breadcrumb from 'primevue/breadcrumb';
import { useExplorerStore } from '@/stores/explorerStore';

const explorerStore = useExplorerStore();

const items = computed(() => {
  return explorerStore.breadcrumbs.map((crumb, index) => ({
    label: crumb.label,
    // Only make non-last items clickable
    command: index < explorerStore.breadcrumbs.length - 1
      ? () => handleBreadcrumbClick(crumb.id)
      : undefined,
  }));
});

const handleBreadcrumbClick = (sectionId?: string) => {
  if (sectionId) {
    const section = explorerStore.findSectionById(sectionId);
    if (section) {
      explorerStore.setActiveSection(section);
    }
  } else {
    // Clicking domain breadcrumb - clear section
    explorerStore.setActiveSection(null);
  }
};
</script>

<style scoped>
.breadcrumb-custom :deep(.p-breadcrumb) {
  background: transparent;
  border: none;
  padding: 0;
}

.breadcrumb-item {
  font-size: 0.875rem;
  transition: color 0.2s;
}

.breadcrumb-custom :deep(.p-breadcrumb-separator) {
  color: var(--text-tertiary);
  margin: 0 0.5rem;
}
</style>
